import { CanvasTexture, Group, Mesh, MeshBasicMaterial, PlaneGeometry } from "three";
import { map as leafletMap, Point, TileLayer } from "leaflet";
import { Renderable } from "../rendering/renderable/Renderable";
const gridGeometry = new PlaneGeometry(0.5, 0.5, 1, 1);
class FlaVRTileLayer extends TileLayer {
    constructor(renderer, modelUID, urlTemplate, options) {
        super(urlTemplate, options);
        this.renderer = renderer;
        this.modelUID = modelUID;
        this.grid = {};
        this.minBounds = new Point(0, 0);
        this.maxBounds = new Point(0, 0);
        this.numTiles = new Point(0, 0);
    }
    destroy() {
        this.group && this.group.parent && this.group.parent.remove(this.group);
    }
    createTile(coords, done) {
        if (coords.x === this.maxBounds.x || coords.y === this.maxBounds.y) {
            return document.createElement("div");
        }
        const tile = document.createElement("img");
        const localCoords = new Point(coords.x - this.minBounds.x, coords.y - this.minBounds.y);
        tile.onload = () => {
            done(undefined, tile);
            this.drawToTexture(tile, localCoords);
        };
        tile.onerror = () => {
            const errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute("src") !== errorUrl) {
                tile.src = errorUrl;
            }
            done(undefined, tile);
        };
        tile.crossOrigin = "";
        /* if (this.options.crossOrigin || this.options.crossOrigin === '') {
          tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
        } */
        tile.alt = "";
        tile.setAttribute("role", "presentation");
        tile.src = this.getTileUrl(coords);
        return tile;
    }
    onAdd(map) {
        const bounds = map.getPixelBounds();
        if (bounds.max && bounds.min) {
            const tileSize = super.getTileSize();
            this.minBounds.x = Math.floor(bounds.min.x / tileSize.x);
            this.minBounds.y = Math.floor(bounds.min.y / tileSize.y);
            this.maxBounds.x = Math.floor(bounds.max.x / tileSize.x);
            this.maxBounds.y = Math.floor(bounds.max.y / tileSize.y);
            const bSize = this.maxBounds.subtract(this.minBounds);
            this.numTiles.x = bSize.x + 1;
            this.numTiles.y = bSize.y + 1;
            this.createMesh();
        }
        super.onAdd(map);
        return this;
    }
    onRemove(map) {
        super.onRemove(map);
        return this;
    }
    createMesh() {
        this.group = new Group();
        this.group.matrixAutoUpdate = false;
        this.group.frustumCulled = false;
        for (let x = 0; x < 2; ++x) {
            for (let y = 0; y < 2; ++y) {
                this.createGridElement(x, y);
            }
        }
        this.renderer.addToScene(this.group, this.modelUID);
    }
    createGridElement(gridIndexX, gridIndexY) {
        const tileSize = super.getTileSize();
        const numTilesInGridX = Math.floor(this.numTiles.x / 2);
        const numTilesInGridY = Math.floor(this.numTiles.y / 2);
        const gridIndex = gridIndexX + gridIndexY * 2;
        const canvas = document.createElement("canvas");
        canvas.width = tileSize.x * numTilesInGridX;
        canvas.height = tileSize.y * numTilesInGridY;
        const context = canvas.getContext("2d");
        if (context) {
            const texture = new CanvasTexture(canvas);
            texture.needsUpdate = true;
            const mesh = new Mesh(gridGeometry, new MeshBasicMaterial({ map: texture }));
            mesh.matrixAutoUpdate = false;
            mesh.frustumCulled = false;
            mesh.position.x = gridIndexX * 0.5 - 0.5 / 2;
            mesh.position.z = gridIndexY * 0.5 - 0.5 / 2;
            mesh.rotation.x = -Math.PI / 2;
            mesh.updateMatrix();
            if (this.group === undefined) {
                throw new Error("We expect this.group to be defined here.");
            }
            this.group.add(mesh);
            this.grid[gridIndex] = { mesh, canvas, context, texture };
        }
    }
    drawToTexture(image, localCoords) {
        const tileSize = super.getTileSize();
        const numTilesInGridX = Math.floor(this.numTiles.x / 2);
        const numTilesInGridY = Math.floor(this.numTiles.y / 2);
        const gridIndexX = Math.floor(localCoords.x / numTilesInGridX);
        const gridIndexY = Math.floor(localCoords.y / numTilesInGridY);
        const gridIndex = gridIndexX + gridIndexY * 2;
        const localX = localCoords.x - gridIndexX * numTilesInGridX;
        const localY = localCoords.y - gridIndexY * numTilesInGridY;
        const gridMesh = this.grid[gridIndex];
        gridMesh.context.drawImage(image, localX * tileSize.x, localY * tileSize.x, tileSize.x, tileSize.y);
        gridMesh.texture.needsUpdate = true;
    }
}
export class MapRenderable extends Renderable {
    constructor(owner) {
        super(owner);
        this.type = MapRenderable.typestatic;
        this.mapElement = document.createElement("div");
        this.mapElement.style.width = "4096px";
        this.mapElement.style.height = "4096px";
        this.mapElement.style.visibility = "hidden";
        document.body.appendChild(this.mapElement);
        this.map = leafletMap(this.mapElement, {
            attributionControl: false,
            zoomControl: false,
            dragging: false,
            keyboard: false
        });
        /* this.layer = new FlaVRTileLayer(
          this.owner.renderer,
          "https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}",
          {
            id: "mapbox.streets",
            accessToken:
              "pk.eyJ1IjoibXdpcnRoZmxhdmlhIiwiYSI6ImNqaGl1OWV4bzBvYWYzN3J4bnFuZXQzdWoifQ.0jrry12cnE2VeALAfZwqqw",
            tileSize: 256,
            crossOrigin: false,
          }
        ).addTo(this.map);/**/
        this.layer = new FlaVRTileLayer(this.owner.renderer, this.owner.modelUID, "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(this.map); /**/
    }
    destroy() {
        this.layer.destroy();
        this.mapElement.remove();
    }
    setVisible(visible) {
        if (this.layer.group)
            this.layer.group.visible = visible;
    }
    updateFacet(facet) {
        this.mapElement.style.width = `${facet.width}px`;
        this.mapElement.style.height = `${facet.height}px`;
        this.map.setView([facet.latitude, facet.longitude], facet.zoom);
    }
    updateTransform() {
        if (!this.layer.group)
            return;
        this.layer.group.matrix.copy(this.owner.matrixWorld);
        this.layer.group.updateMatrixWorld(true);
    }
}
MapRenderable.typestatic = "Map";
